import { get, omit } from 'lodash';
import { v4 as uuid } from 'uuid';
import { getCurrentSessionURL } from '@fullstory/browser';

export enum LoggerStatusEnum {
  debug = 'debug',
  info = 'info',
  warn = 'warn',
  error = 'error',
}

const pathsToRemoveFromErrorContext = [
  'headers',
  'config.headers',
  'context.responses.pages',
  'context.data.responses.pages',
  'context.meta',
  'socket.json',
  'socket._callbacks',
];

const postLog = (data: {
  status: LoggerStatusEnum;
  [key: string]: unknown;
}) => {
  let consoleStatus = data.status;
  if (!consoleStatus || consoleStatus === LoggerStatusEnum.debug) {
    consoleStatus = LoggerStatusEnum.info;
  }
  // eslint-disable-next-line no-console
  console[consoleStatus](data.message, data);
};

export const LOGGER_DATA_LOCAL_STORAGE_KEY = 'lh:logger_data';

export const sendLog = (
  message: string,
  messageContext: any,
  status: LoggerStatusEnum,
) => {
  const env = get(process.env, 'NODE_ENV', '');
  // you need to comment this line to test it locally
  if (env === 'development') return;

  let error: Object = omit(messageContext, pathsToRemoveFromErrorContext);

  if (messageContext instanceof ErrorEvent) {
    error = {
      stack: get(messageContext, 'error.stack', ''),
      filename: messageContext.filename,
    };
  }

  const localStorageData = JSON.parse(
    window.localStorage.getItem(LOGGER_DATA_LOCAL_STORAGE_KEY) || '{}',
  );
  const version = get(process.env, 'REACT_APP_COMMIT_HASH', '');
  const isPatientApp =
    get(process.env, 'REACT_APP_PREFIX', '') === 'lh_patient';

  const log = {
    service: isPatientApp ? 'patient-app' : 'web-app',
    errorId: uuid(),
    env,
    time: new Date().toISOString(),
    // env data
    host: window.location.host,
    path: window.location.href,
    userAgent: window.navigator.userAgent,
    version,
    // app data
    ...error,
    ...localStorageData,
    message,
    status,
    fullstory: isPatientApp
      ? "Fullstory isn't available on patient-app"
      : getCurrentSessionURL(true),
  };
  postLog(log);
};
